import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Message } from 'semantic-ui-react';
import { IRootState } from 'store';
import * as App from 'application';

export interface IEmailPendingProps {
    onResendEmail();
}

const mapStateToProps = (state: IRootState) => ({

});

const mapDispatchToProps = (dispatch) => ({
    onResendEmail: () => App.EmailConfirmation.reSend(dispatch)
})

export const EmailPendingView: React.SFC<IEmailPendingProps> = (props) => {
    return (<div>
        <Message info>
            <Message.Header>Please check your inbox for confirmation email and click the link included.</Message.Header>
            <p>Didn't receive email?</p>
            <Button primary onClick={props.onResendEmail} >Resend Confirmation Email</Button>
        </Message>
    </div>
    );
}

export const EmailPending = connect(mapStateToProps, mapDispatchToProps)(EmailPendingView)



// WEBPACK FOOTER //
// ./src/components/presentational/views/EmailPending/index.tsx